<template>
  <div class="flex h-full">
    <el-tabs v-model="activeName" tab-position="left" class="w-152px h-130px ">
      <el-tab-pane label="全体人员名册" name="allPersonal"> </el-tab-pane>
      <el-tab-pane label="特种作业人员名单" name="specialPersonal"> </el-tab-pane>
      <el-tab-pane label="工作负责人名册" name="workLeaderpersonal"> </el-tab-pane>
    </el-tabs>
    <div class="ml-10px flex-1 h-full">
      <WholePerson v-if="activeName === 'allPersonal'" :contractorId="contractorId" />
      <SpecialPerson v-if="activeName === 'specialPersonal'" :contractorId="contractorId" />
      <WorkLeaderPerson v-show="activeName === 'workLeaderpersonal'" :contractorId="contractorId" />
    </div>
  </div>
</template>
<script>
import WholePerson from './wholePerson'
import SpecialPerson from './specialPersonal'
import WorkLeaderPerson from './workLeaderpersonal'

export default {
  components: {
    WholePerson,
    SpecialPerson,
    WorkLeaderPerson,
  },
  props: {
    contractorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeName: 'allPersonal',
    }
  },
}
</script>
